import { HarassmentRiskCardProps } from '@diversioteam/diversio-ds'
import { loadRiskBanner } from 'sagas/network'

import { Queries } from 'api/queries.enum'

import { useQuery } from './useQuery'

export type GetRiskBannerResponse = HarassmentRiskCardProps<'a'> | Record<string, never>

export const useRiskBanner = () => {
    const query = useQuery<GetRiskBannerResponse, Error>({
        queryKey: [Queries.getRiskBanner],
        queryFn: loadRiskBanner,
    })

    return query
}
